"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.news = void 0;
const axios_class_1 = require("./axios.class");
class News {
    /**
     * Fetch published news by space.
     */
    async getNews(space) {
        const { data } = await axios_class_1.axios.get(`/v1/news/${space}`);
        return data;
    }
    /**
     * Fetch all news for a given space including unpublished.
     */
    async getAllNews(spaceId) {
        const { data } = await axios_class_1.axios.get(`/v1/news/all/${spaceId}`);
        return data;
    }
    /**
   * Fetch all news by clientId including unpublished.
   */
    async getAllNewsByClientId() {
        const { data } = await axios_class_1.axios.get(`/v1/news/client`);
        return data;
    }
    /**
     * Create a news item.
     */
    async createNews(newsData) {
        const { data } = await axios_class_1.axios.post(`/v1/news`, newsData);
        return data;
    }
    /**
     * Update a specific news item.
     */
    async updateNews(newsId, updatedData) {
        const { data } = await axios_class_1.axios.post(`/v1/news/edit/${newsId}`, updatedData);
        return data;
    }
    /**
     * Update a UrlClickedCount news.
     */
    async updateUrlClicked(newsId) {
        return await axios_class_1.axios.patch(`/v1/news/urlClicked/${newsId}`);
    }
    /**
     * Update a updateNewsViewCount news.
     */
    async updateViewCount(newsId) {
        return await axios_class_1.axios.patch(`/v1/news/viewCount/${newsId}`);
    }
}
exports.news = new News();
